export default class GameSettings {
	constructor() {
	}
}